import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Avatar from "@mui/material/Avatar"
import { MONO } from "../constants"

export function AddUserPanel({ users, openChats, onAdd, me }) {
  return (
    <Box sx={{ flex: 1, overflowY: "auto", p: 1.5 }}>
      <Typography sx={{ color: "rgba(var(--app-fg-rgb),0.35)", fontFamily: MONO, fontSize: "0.63rem", mb: 1 }}>
        Devs — click to open private chat
      </Typography>
      {users.length === 0 && (
        <Typography sx={{ color: "rgba(var(--app-fg-rgb),0.22)", fontFamily: MONO, fontSize: "0.68rem" }}>
          No linked devs found.
        </Typography>
      )}
      {users.map((u) => {
        const isSelf = u.username === me
        const alreadyOpen = openChats.includes(u.username)
        return (
          <Box key={u.username} onClick={() => !isSelf && onAdd(u.username)}
            sx={{ display: "flex", alignItems: "center", gap: 1, px: 1.25, py: 0.75,
              borderRadius: 1, mb: 0.5, cursor: isSelf ? "default" : "pointer",
              backgroundColor: "rgba(var(--app-fg-rgb),0.03)", border: "1px solid rgba(var(--app-fg-rgb),0.05)",
              "&:hover": !isSelf ? { backgroundColor: "rgba(245,158,11,0.07)", borderColor: "rgba(245,158,11,0.18)" } : {} }}>
            <Box sx={{ width: 6, height: 6, borderRadius: "50%",
              backgroundColor: u.online ? "var(--app-success)" : "rgba(var(--app-fg-rgb),0.18)", flexShrink: 0 }} />
            {u.avatar_b64
              ? <Avatar src={u.avatar_b64} sx={{ width: 18, height: 18, flexShrink: 0 }} />
              : <Avatar sx={{ width: 18, height: 18, flexShrink: 0, bgcolor: "rgba(var(--app-fg-rgb),0.06)", fontSize: 9 }}>
                  {(u.display_name ?? u.username)[0]?.toUpperCase()}
                </Avatar>}
            <Typography sx={{ flex: 1, fontFamily: MONO, fontSize: "0.71rem",
              color: isSelf ? "rgba(var(--app-fg-rgb),0.28)" : (u.name_color ?? "rgba(var(--app-fg-rgb),0.82)"),
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {u.display_name ?? u.username}{isSelf ? " (you)" : ""}
            </Typography>
            {alreadyOpen && !isSelf && (
              <Typography sx={{ fontFamily: MONO, fontSize: "0.58rem", color: "rgba(var(--app-fg-rgb),0.28)" }}>open</Typography>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
